import { Color } from '@billy/design-system'
import { useEffect, useState } from 'react'

import * as Styled from './styles'
import { DotToCheckmarkSize } from './types'

interface DotToCheckmarkProps {
  isSuccess?: boolean
  isAnimated?: boolean
  isUpcoming?: boolean
  size?: DotToCheckmarkSize
}

export const DotToCheckmark = ({
  isSuccess = false,
  isAnimated = false,
  isUpcoming = false,
  size = 's',
}: DotToCheckmarkProps) => {
  const [isAnimating, setIsAnimating] = useState(false)

  useEffect(() => {
    if (isAnimated) {
      setIsAnimating(true)
    }
  }, [isAnimated])

  // Calculate stroke dash lengths
  const shortLineLength = 50
  const longLineLength = 128

  return (
    <Styled.DotToCheckmarkContainer isUpcoming={isUpcoming} size={size}>
      <Styled.Dot isAnimating={isAnimating} isUpcoming={isUpcoming} isSuccess={isSuccess} size={size} />

      <Styled.Checkmark viewBox="0 0 16 16" size={size}>
        {/* first line (short) */}
        <Styled.LineShort
          x1="3"
          y1="8"
          x2="7"
          y2="12"
          stroke={isUpcoming ? Color.Grey200 : Color.Lavender500}
          strokeWidth="2"
          strokeLinecap="round"
          strokeDasharray={shortLineLength}
          strokeDashoffset={isSuccess || isAnimating ? 0 : shortLineLength}
          isAnimating={isAnimating}
        />

        {/* second line (long) */}
        <Styled.LineLong
          x1="7"
          y1="12"
          x2="13"
          y2="5"
          stroke={isUpcoming ? Color.Grey200 : Color.Lavender500}
          strokeWidth="2"
          strokeLinecap="round"
          strokeDasharray={longLineLength}
          strokeDashoffset={isSuccess || isAnimating ? 0 : longLineLength}
          isAnimating={isAnimating}
        />
      </Styled.Checkmark>
    </Styled.DotToCheckmarkContainer>
  )
}
